module.exports = __webpack_public_path__ + "static/media/stitcher_podcasts.43cab3d1.svg";